(() => {
  const SELECTOR = '[data-product-hotspots]';
  if (window.GlowbyHK3DLoader) {
    window.GlowbyHK3DLoader.scan();
    return;
  }

  const observers = new WeakMap();
  let runtimePromise;

  const requestRuntime = (section) => {
    if (section.dataset.runtimeRequested === 'true') return;
    section.dataset.runtimeRequested = 'true';
    observers.get(section)?.disconnect();
    const runtimeUrl = section.dataset.runtimeUrl;
    if (!runtimeUrl) return;
    if (window.GlowbyHK3D) {
      window.GlowbyHK3D.mount(section);
      return;
    }
    if (!runtimePromise) {
      runtimePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = runtimeUrl;
        script.async = true;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.append(script);
      });
    }
    runtimePromise.then(() => window.GlowbyHK3D?.mount(section)).catch(() => {
      section.classList.add('product-hotspots--fallback');
    });
  };

  const observe = (section) => {
    if (section.dataset.runtimeRequested === 'true' || observers.has(section)) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) requestRuntime(section);
    }, { rootMargin: '400px 0px' });
    observer.observe(section);
    observers.set(section, observer);
  };

  const scan = (root = document) => {
    if (root.matches?.(SELECTOR)) observe(root);
    root.querySelectorAll?.(SELECTOR).forEach(observe);
  };

  window.GlowbyHK3DLoader = { scan };
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(SELECTOR) ? event.target : event.target.querySelector?.(SELECTOR);
    if (!section) return;
    observers.get(section)?.disconnect();
    observers.delete(section);
    window.GlowbyHK3D?.unmount(section);
  });
})();
